import type React from "react"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const UserDashboard: React.FC = () => {
  const navigate = useNavigate()
  
  useEffect(() => {
    // Redirect to the enhanced user dashboard
    navigate('/user-dashboard')
  }, [navigate])
  
  // Show a loading message while redirecting
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div>Loading enhanced dashboard...</div>
    </div>
  )
}

export default UserDashboard
